import { forwardRef } from "react";
import styled from "styled-components";
import css from "@styled-system/css";

import { FilterButtonProps } from "./filterButton.type";
import Button from "../Button/BaseButton";
import Count, { CountProps } from "../Count/Count";
import Icon from "../Icon/Icon";
import Typography from "../Typography/Typography";

const StyledFilterButton = styled(Button)`
  height: 74px;
  width: 124px;
  flex-wrap: wrap;
  justify-content: space-between;
  ${css({
    pt: 2,
    px: 2,
    pb: 6,
    "&:active": {
      "*": {
        color: "primary-white",
      },
    },
  })}
`;

const FilterLabel = styled(Typography)`
  flex: 100%;
  color: inherit;
  ${css({
    fontSize: "body-small",
  })}
`;

const FilterCount = styled(Count)<CountProps & { isApplied?: boolean }>`
  padding: 0;
  background-color: transparent;
  ${(props) =>
    css({
      fontSize: "body-small",
      color: props.isApplied ? "primary-white" : "grey-blue"
    })}
`;

const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
  (
    {
      label,
      icon,
      iconWeight = "regular",
      count,
      isApplied = false,
      analytics,
      ...rest
    },
    ref
  ) => {
  
  return (
    <StyledFilterButton
      className={isApplied ? "active" : undefined}
      variant="button"
      ref={ref}
      data-en={analytics?.eventName}
      data-ec={analytics?.eventCategory}
      data-el={analytics?.eventLabel}
      data-ea={analytics?.eventAction}
      data-es={analytics?.eventSection}
      data-et={analytics?.eventType}
      data-ev={analytics?.eventValue}
      {...rest}
    >
      <Icon
        name={icon}
        width="18px"
        weight={iconWeight}
      />
      <FilterCount 
        number={count}
        isApplied={ isApplied }
      />
      <FilterLabel 
        variant="label"
      >
        {label}
      </FilterLabel>
    </StyledFilterButton>
  );
});

export default FilterButton;